import React from 'react';

import { ArrowRightIcon } from '$partials/icon';
import { Button } from '$partials/ui';
import { formatLinkBlockToUrl, formatPrice, formatRentFrequency } from '$utilities/format';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/listings').OffMarketBoxItem}
 */
const OffMarketBox = ({
    __typename,
    area,
    heading,
    offMarketLink,
    outwardCode,
    priceGbp,
    publicSellingStatus,
    rentFrequency,
    rentGbp,
    slug
}) => {
    const price = __typename === 'PropertyPage' ? formatPrice(priceGbp) : `${formatPrice(rentGbp)} ${formatRentFrequency(rentFrequency)}`;
    const cta = offMarketLink?.[0];

    const getParams = () => {
        const params = `type=${__typename === 'RentalPropertyPage' ? 'rent' : 'sale'}&slug=${slug}`;
        window.location.href=formatLinkBlockToUrl(cta?.link, params);
    };

    return (
        <article className='px5 md-px6 pt5 pb5 md-pb8 flex off-market-item'>
            <div className='flex flex-col md-flex-row col-12 black pt5 md-pt8'>
                <div className='pt3 md-pt0 mb5 md-col-4 pr6 flex-col'>
                    <div>
                        <p className='type-style-5'>Off-Market</p>
                    </div>
                </div>
                <div className='md-col-8 md-pr10 flex-col flex'>
                    <div className='flex flex-col flex-grow'>
                        {publicSellingStatus === 'Sold' && (
                            <p className='type-style-5'>Asking price:</p>
                        )}
                        <p className='type-style-5'>{price}</p>
                        <p className='type-style-5'>{area}{' '}{outwardCode}</p>
                        <h3 className='type-style-1 sans-serif mt12 md-mt8'>{heading}</h3>
                    </div>
                    {cta && publicSellingStatus !== 'Sold' && publicSellingStatus !== 'Rented' && (
                        <Button
                            as='a'
                            className = 'bg-none type-style-5 link-reset mb3 md-mb0'
                            iconClassName='bg-sand black button border-radius-100px p3 md-p5'
                            look='underline'
                            onClick={() => getParams()}
                            renderIcon={<ArrowRightIcon/>}>
                            {cta.label}
                        </Button>
                    )}
                </div>
            </div>
        </article>

    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default OffMarketBox;
